import React from 'react'
import { Outlet } from 'react-router-dom'

const BankPayment = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default BankPayment